import React, { useState } from 'react';
import AllowCameraAccessPopupMobile from '../../../components/FormRegister/AllowCameraAccessPopup/mobile';
import { useCameraCheck } from '../../../hooks/useCameraCheck';

const withCheckAllowCameraAccessOnMobileDevice = (Component) => {
  const CheckAllowCameraAccessOnMobileDeviceComponent = (props) => {
    const { checkAllowTakePhoto } = useCameraCheck();

    const { initialOpen, isReferralLinkChecking } = props || {};

    const [isOpenAllowCameraAccessPopup, setOpenAllowCameraAccessPopup] =
      useState(initialOpen);

    const handleOnToggleAllowCameraAccessPopup = () => {
      setOpenAllowCameraAccessPopup(!isOpenAllowCameraAccessPopup);
    };

    const newProps = {
      ...props,
    };
    return (
      <>
        {!checkAllowTakePhoto &&
          isOpenAllowCameraAccessPopup &&
          !isReferralLinkChecking && (
            <AllowCameraAccessPopupMobile
              isOpen={true}
              onClose={handleOnToggleAllowCameraAccessPopup}
            />
          )}
        <Component
          {...newProps}
          handleOnToggleAllowCameraAccessPopup={
            handleOnToggleAllowCameraAccessPopup
          }
        />
      </>
    );
  };
  return CheckAllowCameraAccessOnMobileDeviceComponent;
};

export default withCheckAllowCameraAccessOnMobileDevice;
